import { configureStore } from "@reduxjs/toolkit";

import {
  MessagesReducer,
  RepliesReducer,
  PropertyReducer,
  DatePickerReducer,
  WindowReducer,
  GalleryReducer,
  PolicyReducer,
  BadgeSwitchReducer,
  VideosReducer,
  UnitReducer,
  MascotSettingsReducer,
  ParamsReducer,
  OptionBoxReducer,
  ScheduleTourReducer,
  StandaloneReducer,
  CalculatorReducer,
} from "slices";
import { buildReduxEnhancer } from "observabilityRedux";

// Redux breadcrumbs + whitelisted state to Sentry — PRODUCTION ONLY (gated on the DSN, like
// the rest of observability). Non-prod → `enhancers` undefined → RTK defaults, exactly as before.
const observabilityEnabled = Boolean(process.env.REACT_APP_SENTRY_DSN);

const store = configureStore({
  reducer: {
    messages: MessagesReducer,
    replies: RepliesReducer,
    property: PropertyReducer,
    datepicker: DatePickerReducer,
    window: WindowReducer,
    gallery: GalleryReducer,
    units: UnitReducer,
    policy: PolicyReducer,
    badgeSwitch: BadgeSwitchReducer,
    videos: VideosReducer,
    mascotSetting: MascotSettingsReducer,
    params: ParamsReducer,
    optionBox: OptionBoxReducer,
    scheduleTour: ScheduleTourReducer,
    standalone: StandaloneReducer,
    calculator: CalculatorReducer,
  },
  enhancers: observabilityEnabled ? (defaultEnhancers) => [...defaultEnhancers, buildReduxEnhancer()] : undefined,
});

export default store;
